export function isInAppBrowser(): boolean {
  if (typeof window !== "undefined") {
    const qs = window.navigator.userAgent;
    return qs.indexOf("inappbrowser") > -1 ? true : false;
  } else {
    return false;
  }
}
export function isInAppAndroidBrowser(): boolean {
  const qs = window.navigator.userAgent;
  return qs.indexOf("inappbrowser") > -1 && qs.indexOf("android") > -1
    ? true
    : false;
}
export function isInAppIOSBrowser(): boolean {
  const qs = window.navigator.userAgent;
  return qs.indexOf("inappbrowser") > -1 && qs.indexOf("ios") > -1
    ? true
    : false;
}
export function isMobile(): boolean {
  return "ontouchstart" in document.documentElement;
}
